export default __webpack_public_path__ + "static/media/master.c9a17af4.png";